<template>
  <div :class="{ expanded: expanded }" class="accordion-group">
    <div class="accordion-bar" @click="expanded = !expanded">
      <h3>{{ title }} ({{ products.length }})</h3>
      <div class="accordion-icon-wrapper">
        <i v-if="!expanded" class="fal fa-chevron-down"></i>
        <i v-else class="fal fa-chevron-up"></i>
      </div>
    </div>
    <div class="accordion-content py-3">
      <h3>{{ title }}</h3>
      <div
        class="category-content"
        v-if="getCategory(category)"
        v-html="getCategory(category).description"
      ></div>
      <div class="row">
        <ProductLift
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductLift from "./ProductLift";
import { mapGetters } from "vuex";
export default {
  name: "Accordion",
  components: { ProductLift },
  props: {
    title: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    ...mapGetters(["getCategory"]),
  },
};
</script>

<style lang="scss" scoped>
.accordion-group {
  margin-bottom: 1rem;
  .accordion-bar {
    padding: 16px 24px;
    background-color: var(--bs-green);
    color: var(--bs-light);
    display: grid;
    grid-template-columns: 90% 10%;
    cursor: pointer;
    h3 {
      font-weight: bold;
      font-size: 1.1rem;
      line-height: 32px;
      letter-spacing: 0.2px;
      margin-bottom: 0;
    }
    .accordion-icon-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      i {
        font-size: 1.1rem;
      }
    }
  }
  .accordion-content {
    display: none;
  }
  &.expanded {
    .accordion-content {
      display: block;
    }
  }
}
</style>
